define('TescoMobile_Checkout/js/action/recollect-shipping-rates-mixin',['mage/utils/wrapper', 'Magento_Checkout/js/model/quote'], function (wrapper, quote) {
  'use strict';

  return function (recollectShippingRates) {
    return wrapper.wrap(recollectShippingRates, function (originalRecollectShippingRates) {
      if (quote.shippingAddress()) {
        originalRecollectShippingRates();
      }
    });
  };
});

